import { FORM_REPOSITORY, FindFormByIdUseCase, FIND_FORM_BY_ID_USE_CASE, GET_SECTION_SUMMARIES_USE_CASE, GetSectionSummariesUseCase, FIND_FORM_RELEASE_BY_ID_USE_CASE, FindFormReleaseByIdUseCase, FORM_RELEASE_REPOSITORY } from '@module/form';
export var formUseCaseProviders = [{
  provide: FIND_FORM_BY_ID_USE_CASE,
  useFactory: function useFactory(formRepository) {
    return new FindFormByIdUseCase(formRepository);
  },
  inject: [FORM_REPOSITORY]
}, {
  provide: FIND_FORM_RELEASE_BY_ID_USE_CASE,
  useFactory: function useFactory(formReleaseRepository) {
    return new FindFormReleaseByIdUseCase(formReleaseRepository);
  },
  inject: [FORM_RELEASE_REPOSITORY]
}, {
  provide: GET_SECTION_SUMMARIES_USE_CASE,
  useFactory: function useFactory(formRepository) {
    return new GetSectionSummariesUseCase(formRepository);
  },
  inject: [FORM_REPOSITORY]
}];